// Braces by Garcia (pilot brand). Moved verbatim from the original single-brand
// config.ts so the live bond-booking-widget keeps identical behavior. Default brand.
import type { BrandConfig } from "./types";

export const garcia: BrandConfig = {
  slug: "garcia",
  brandId: "garcia",
  brandName: "Braces by Garcia",
  logo: "https://bracesbygarcia.com/wp-content/uploads/2023/07/BBG_Logo_HORZ_400x100-160x33.png",
  phone: "(951) 296-5100",
  phoneHref: "tel:+19512965100",
  theme: { primary: "#70BF44", primaryDark: "#5BA537" },
  locales: ["en", "es"],
  locations: {
    GARCIA_MENIFEE: {
      id: "GARCIA_MENIFEE",
      name: "Menifee",
      addressLines: ["26905 Newport Rd, Suite 101", "Menifee, CA 92584"],
      mapsUrl: "https://maps.google.com/?q=26905+Newport+Rd+Suite+101+Menifee+CA+92584",
      timezone: "America/Los_Angeles",
    },
    GARCIA_TEMECULA: {
      id: "GARCIA_TEMECULA",
      name: "Temecula",
      addressLines: ["40285 Winchester Rd, Suite 101", "Temecula, CA 92591"],
      mapsUrl: "https://maps.google.com/?q=40285+Winchester+Rd+Suite+101+Temecula+CA+92591",
      timezone: "America/Los_Angeles",
    },
  },
  locationAliases: { MENIFEE: "GARCIA_MENIFEE", TEMECULA: "GARCIA_TEMECULA" },
  // Native booking restored (2026-07): the backend now mints the Edge Booking
  // token via the Turnstile/CapSolver public-token path, so the widget's own
  // slot picker + booking works again (single form, no double entry). To revert
  // to the Ortho2 SPA handoff, uncomment the line below:
  // ortho2BookingUrl: "https://edgebooking.ortho2.com/search?catalog=8f4cd459-1981-4dd4-8d25-b473e83f96cc&code=webbnu",
};
